export enum FacilityCodeType {
  Vehicle = 'Vehicle',
  AccessCard = 'AccessCard',
}
